import * as React from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useBalance, useContractReads, useAccount } from 'wagmi';
import { ethers } from 'ethers';
import { multiMint } from '../multiMint';
import { Withdraw } from './Withdraw';
import { OwnedNfts } from './OwnedNfts';
import { Inv } from './multiselect/Inv';
import { Cart } from './multiselect/Cart';

export function Home(props) {
  const { address, isConnected } = useAccount();
  const [readState, setReadState] = React.useState({
    ids: [],
    allIds: [],
    bigPrice: 0,
    ethPrice: 0,
    ownedNfts: [],
    ownedQty: 0,
    collectionName: '',
    collectionSymbol: '',
    soldIds: [],
  });
  const [cart, setCart] = React.useState([]);
  const [inCartStatus, setInCartStatus] = React.useState({});
  const [sold, setSold] = React.useState({});
  const [contractOwner, setContractOwner] = React.useState(false);
  const [balance, setBalance] = React.useState(0);
  const multimint = { address: multiMint.addr, abi: multiMint.abi };
  const { data: getBalance } = useBalance({
    address: multimint.address,
    watch: true,
    onSuccess: (result) => {
      const newBalance = result.formatted;
      setBalance(newBalance);
      return getBalance;
    },
    onError: (error) => {
      console.log('readbalanceerror', error);
    },
  });
  const { data, isLoading, isError } = useContractReads({
    contracts: [
      { ...multimint, functionName: 'getAvailableTokens' }, //0
      { ...multimint, functionName: 'price' }, //1
      {
        ...multimint,
        functionName: 'tokensOfAddress', //2
        args: [props.connected],
      },
      { ...multimint, functionName: 'balanceOf', args: [props.connected] }, //3
      { ...multimint, functionName: 'name' }, //4
      { ...multimint, functionName: 'symbol' }, //5
      { ...multimint, functionName: 'owner' }, //6
    ],
    allowFailure: true,
    watch: true,
    onSuccess: (result) => {
      let ids = [...result[0]].sort(function (a, b) {
        return a - b;
      });
      const totalSupply = 100;
      const allIds = [...Array(totalSupply).keys()].map((i) => i + 1);
      // initialize setSold to false for all ids
      allIds.forEach((id) => {
        if (!sold[id]) {
          setSold((prevSold) => ({ ...prevSold, [id]: false }));
        }
      });
      const soldIds = allIds.filter((id) => !ids.includes(id));
      soldIds.forEach((id) => {
        setSold((prevSold) => ({ ...prevSold, [id]: true }));
      });

      const bigPrice = result[1];
      const eth = ethers.utils.formatEther(bigPrice);
      let ownedNfts = result[2];
      let ownedQty = result[3];
      let collectionName = result[4];
      let collectionSymbol = result[5];
      const devAddr = '0x952440136379bA4cEEf92FF49fb122C4Ace0B810';
      const contractOwner = result[6];
      if (address === contractOwner || address === devAddr) {
        setContractOwner(true);
      }
      setReadState({
        ids,
        allIds,
        bigPrice,
        eth,
        ownedNfts,
        ownedQty,
        collectionName,
        collectionSymbol,
        soldIds,
      });
      return {
        result,
        ids,
        allIds,
        bigPrice,
        ownedNfts,
        ownedQty,
        collectionName,
        collectionSymbol,
      };
    },
  });

  function addToCart(id) {
    setCart((prevCart) => [...prevCart, id]);
    setInCartStatus((prevStatus) => ({ ...prevStatus, [id]: true }));
  }

  function removeFromCart(id) {
    setCart((prevCart) => prevCart.filter((item) => item !== id));
    setInCartStatus((prevStatus) => ({ ...prevStatus, [id]: false }));
  }
  function resetCart() {
    setCart([]);
    setInCartStatus({});
  }
  React.useEffect(() => {
    const soldIds = readState.allIds.filter(
      (id) => !readState.ids.includes(id)
    );
    setSold((prevSold) => {
      const updatedSold = { ...prevSold };
      soldIds.forEach((id) => {
        if (!prevSold[id]) {
          updatedSold[id] = true;
        }
      });
      return updatedSold;
    });
  }, [readState.ids, readState.allIds]);
  const ownedNftsRef = React.useRef(<OwnedNfts />);
  function scrollOwnedNfts() {
    ownedNftsRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  return isLoading ? (
    <div>loading...</div>
  ) : isError ? (
    <div>error please try again</div>
  ) : (
    <>
      {cart ? (
        <>
          {cart.length > 0 ? null : (
            <div className='flex justify-center '>
              <ConnectButton />
            </div>
          )}
        </>
      ) : null}

      {contractOwner ? <Withdraw bal={balance} addr={multimint.addr} /> : null}
      {cart ? (
        <>
          {cart.length > 0 ? (
            <Cart
              ids={readState.ids}
              cart={cart}
              removeFromCart={removeFromCart}
              bigPrice={readState.bigPrice}
              eth={readState.eth}
              inCartStatus={inCartStatus}
              resetCart={resetCart}
              sold={sold}
              setSold={setSold}
            />
          ) : null}
        </>
      ) : null}
      {readState.ids && sold ? (
        <>
          {readState.ids.length > 0 ? (
            <Inv
              ids={readState.allIds}
              addToCart={addToCart}
              removeFromCart={removeFromCart}
              resetCart={resetCart}
              bigPrice={readState.bigPrice}
              eth={readState.eth}
              inCartStatus={inCartStatus}
              sold={sold}
              setSold={setSold}
              soldIds={readState.soldIds}
              scrollOwnedNfts={scrollOwnedNfts}
            />
          ) : null}
        </>
      ) : null}

      {readState ? (
        <>
          <div ref={ownedNftsRef}>
            {readState.ownedNfts && readState.ownedNfts.length > 0 ? (
              <OwnedNfts ids={readState.ownedNfts} collectionName={data[4]} />
            ) : (
              <div>
                <div>
                  <br></br>
                </div>
                <span style={{ color: '#0178db', fontSize: '1.6em' }}>
                  THE CONNECTED ADDRESS OWNS NO NFTS YET FROM THIS COLLECTION
                </span>
                <div>
                  <br></br>
                  <br></br>
                </div>
              </div>
            )}
          </div>
        </>
      ) : null}
    </>
  );
}
